import $ from 'jquery'; // a necessary evil for slick to work.
import 'slick-carousel';

export default () => {
    let sliders = $('.slider');
    for (let i = 0; i < sliders.length; i++) {

        let slider = $(sliders[i]);
        let sliderContent = slider.find('.slider-content');
        let nextArrow = slider.find('.slide-next');
        let prevArrow = slider.find('.slide-prev');

        sliderContent.slick({
            speed: 300,
            swipeToSlide: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: nextArrow,
            prevArrow: prevArrow,
            accessibility: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            //appendDots: '.slick-dots-container',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ],
        });

        sliderContent.on('swipe', function (event, slick, direction) {
            sliderContent.slick('slickPause');
        });

        nextArrow.on('click', function () {
            sliderContent.slick('slickPause');
        });

        prevArrow.on('click', function () {
            sliderContent.slick('slickPause');
        });
    }
    
}